import { atom } from 'jotai';

// Reason for adding this atom is, due to race condition in CustomField which happens
// because of onTextAreaChange, the value was reset to default one.
// Tried encapsulating in a  hook and as well useState, it does not work
export const paintDiameterSharedState = atom<string>('');
